/*
Sohel 04/04/2023 2698811066 Change title
Guru Prasad 04/04/2023 2698811066 Fixed table width
Sohel 04/05/2023 2698811066 fixed Phase Prepopulate issue
Sohel 04/05/2023 2699823790 Change column positions
Sohel 04/17/2023 2699823790 Added Corporate Value Based on Company
Guru Prasad 04/18/2023 2699823790 Added Trigger code
Ravi 05/31/2023 2699823790 changed delete popup message
Akhila 05/31/2023 2699823790 unsaved changes bug fixed
*/
import React, {createRef, useState, useEffect} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../../components/DialogBox';
import AddClientForm from './AddClientForm';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {useSelector} from 'react-redux';
export default function AddClientTable({
  clientFormData,
  setClientFormData,
  setDeletedClientData,
  deletedClientData,
  setDeletedClientPhaseData,
  deletedClientPhaseData,
  handleDirty,
  label,
  setLabel,
  setDeletedGroupClientPhase,
  getValues,
  rowSelected,
}) {
  const [clientForm, setClientForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [clientRowData, setClientRowData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [isDelete, setIsDelete] = useState(false);
  const {triggerGroupData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const {roleData} = useSelector(({role}) => role);
  const roleDataDisable = roleData?.window?.['Batch Triggers']?.BT;
  const {companyAPIdata} = useSelector(({organization}) => organization);
  // Closed Save and edit Popup(2700430604)
  const handleClientFormClose = () => {
    setClientForm(false);
    setIsEdit(false);
  };

  // Closed delete popup(2700430604)
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const getObjects = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.companyId === option) {
          label = item;
        }
      });
    return label;
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  // delete Client or Agency data(2700430604)
  const handleConfirmDelete = () =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        const dataDelete = [...clientFormData];
        const index = deleteData.tableData.id;
        dataDelete.splice(index, 1);
        setClientFormData([...dataDelete]);
        deletedClientData?.length > 0 ?
          setDeletedClientData([...deletedClientData, deleteData?.groupClientId]) :
          deleteData?.groupClientId ?
            setDeletedClientData([deleteData?.groupClientId]) :
            setDeletedClientData([]);
        resolve();
        setIsDelete(false);
      }, 1000);
      handleDirty(true);
    });

  const columns = [
    {
      title: 'Type',
      field: 'type',
      render: (rowData) => (rowData?.type ? rowData?.type : ''),
    },

    {
      title: 'Company',
      render: (rowData) =>
        rowData?.phase ? getObjects(rowData?.phase, companyAPIdata)?.companyName : '-',
    },
    {
      title: 'Corporate',
      render: (rowData) => (rowData?.corporateName ? rowData?.corporateName : '-'),
    },
    {
      title: 'Site',
      render: (rowData) => (rowData?.siteName ? rowData?.siteName : '-'),
    },
    {
      title: 'Department Code',
      field: 'clientCode',
      render: (rowData) => (rowData?.clientCode ? rowData?.clientCode?.toUpperCase() : '-'),
    },
    {
      title: 'Triggers',
      cellStyle: {minWidth: 300, maxWidth: 300, whiteSpace: 'normal', wordWrap: 'break-word'},
      render: (rowData) => {
        const data = rowData?.eventTactic ? rowData?.eventTactic?.map((i) => i?.code) : [];
        return data?.length > 0 ? data.join(',') : '';
      },
    },
  ];
  const tableRef = createRef();

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title={'Delete Attached Organization'}
        value={`Are you sure you want to delete Attached Organization ?`}
        handleSubmit={handleConfirmDelete}
      />
      <DialogBox
        open={clientForm || isEdit}
        dialogClose={handleClientFormClose}
        title={
          // isEdit && label === "CLIENT"
          //   ? "Edit Client"
          //   : isEdit && label === "AGENCY"
          //   ? "Edit Agency "
          //   : clientForm && label === "CLIENT"
          //   ? "Add Client"
          //   : clientForm && label === "AGENCY"
          //   ? "Add Agency"
          //   : "Attach Agency / Client"
          isEdit ? 'Edit Organization' : 'Attach Organization'
        }
        maxWidth="lg"
        hideFooter={true}
      >
        <AddClientForm
          setClientFormData={setClientFormData}
          clientFormData={clientFormData}
          setClientForm={setClientForm}
          clientRowData={clientRowData}
          setIsEdit={setIsEdit}
          isEdit={isEdit}
          setDeletedClientPhaseData={setDeletedClientPhaseData}
          deletedClientPhaseData={deletedClientPhaseData}
          setLabel={setLabel}
          label={label}
          setDeletedGroupClientPhase={setDeletedGroupClientPhase}
          getValues={getValues}
        />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table custom-batchTable global-field-table custom-actions-icon custom-toolbar-icons trigger-table new-standard-textfields tablescroll-block">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={clientFormData || []}
            tableRef={tableRef}
            textAlign="left"
            options={{
              search: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <EditOutlinedIcon />
                  </>
                ),
                tooltip: 'Edit',
                disabled: triggerGroupData?.groupCode && roleDataDisable?.edit === false,
                onClick: (event, rowData) => {
                  setIsEdit(true);
                  setClientRowData(rowData);
                  setLabel(rowData?.type ? rowData?.type : '');
                },
              },
              {
                icon: () => (
                  <div>
                    <Button
                      variant="outlined"
                      className="search-btn"
                      disabled={
                        triggerGroupData?.groupCode && rowSelected && !roleDataDisable?.edit
                      }
                      onClick={() => {
                        setClientForm(true);
                        setLabel('');
                      }}
                    >
                      <AddIcon /> Attach Organization
                    </Button>
                  </div>
                ),
                disabled: triggerGroupData?.groupCode && rowSelected && !roleDataDisable?.edit,

                isFreeAction: true,
                onClick: () => {
                  setClientForm(true);
                  setLabel('');
                },
              },
              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  tooltip: 'Delete',
                  disabled: triggerGroupData?.groupCode && roleDataDisable?.delete === false,
                  onClick: () => {
                    setIsDelete(true);
                    setDeleteData(rowData);
                    setLabel(rowData?.type ? rowData?.type : '');
                  },
                };
              },
            ]}
            components={{
              Pagination: (props) => (
                // Changed Button Position from table header to footer (2785320447)
                <div className="global-field-table-footer ">
                  <div className="mt-2"></div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
